// Smart API URL detection for auth: login endpoint is under /api/admin
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  const base = (envUrl || '/api').replace(/\/$/, '');
  if (/\/api\/admin$/.test(base)) return base;
  if (/\/api$/.test(base)) return base + '/admin';
  return base + '/admin';
};

export const authProvider = {
  // called when the user attempts to log in
  login: ({ username, password }: { username: string; password: string }) => {
    const apiUrl = getApiUrl();
    
    return fetch(`${apiUrl}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: username,
        password: password
      })
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Login failed');
    })
    .then(data => {
      if (data.success) {
        localStorage.setItem('auth', JSON.stringify({ 
          username: data.data.user.email,
          user: data.data.user,
          token: data.data.token
        }));
        return Promise.resolve();
      }
      throw new Error(data.message || 'Invalid credentials');
    })
    .catch(error => {
      return Promise.reject(new Error(error.message || 'Login failed'));
    });
  },
  // called when the user clicks on the logout button
  logout: () => {
    localStorage.removeItem('auth');
    return Promise.resolve();
  },
  // called when the API returns an error
  checkError: ({ status }: { status: number }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('auth');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return localStorage.getItem('auth')
      ? Promise.resolve()
      : Promise.reject();
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => Promise.resolve(),
  // Get user identity
  getIdentity: () => {
    const auth = localStorage.getItem('auth');
    if (auth) {
      const { user } = JSON.parse(auth);
      return Promise.resolve({ 
        id: user.id, 
        fullName: user.name || 'Admin User', 
        avatar: undefined 
      });
    }
    return Promise.reject();
  },
};
